import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { QuickModeCalculator } from './QuickModeCalculator';
import { TargetModeCalculator } from './TargetModeCalculator';
import { PositionModeCalculator } from './PositionModeCalculator';
import { TrendingUp, Target, DollarSign } from 'lucide-react';

export function MultiModeRiskCalculator() {
  const [activeMode, setActiveMode] = useState('quick');

  return (
    <div className="w-full">
      <Tabs value={activeMode} onValueChange={setActiveMode} className="w-full">
        <TabsList className="grid grid-cols-3 w-full max-w-md mx-auto mb-6">
          <TabsTrigger value="quick" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Quick
          </TabsTrigger>
          <TabsTrigger value="target" className="flex items-center gap-2">
            <Target className="h-4 w-4" />
            Target
          </TabsTrigger>
          <TabsTrigger value="position" className="flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Position
          </TabsTrigger>
        </TabsList>

        <TabsContent value="quick" className="space-y-6">
          <div className="text-center mb-4">
            <h3 className="text-lg font-medium text-foreground">Quick Mode</h3>
            <p className="text-sm text-muted-foreground">
              Enter your TradingView setup to get instant TP/SL calculations
            </p>
          </div>
          <QuickModeCalculator />
        </TabsContent>

        <TabsContent value="target" className="space-y-6">
          <div className="text-center mb-4">
            <h3 className="text-lg font-medium text-foreground">Target Mode</h3>
            <p className="text-sm text-muted-foreground">
              Set your profit/loss targets to find the required percentages
            </p>
          </div>
          <TargetModeCalculator />
        </TabsContent>

        <TabsContent value="position" className="space-y-6">
          <div className="text-center mb-4">
            <h3 className="text-lg font-medium text-foreground">Position Mode</h3>
            <p className="text-sm text-muted-foreground">
              Define your risk amount to optimize position sizing
            </p>
          </div>
          <PositionModeCalculator />
        </TabsContent>
      </Tabs>
    </div>
  );
}